import { useRef, useState } from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Paper,
} from '@mui/material';
import Draggable from 'react-draggable';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import { DownloadOptions } from './DownloadOptions';

export const timings = [
  {
    key: 'fall/early spring',
    label: 'Fall/ Early Spring (pre-Mar 20)',
    variant: 'fall_early_spring',
  },
  { key: 'spring', label: 'Spring' },
  { key: 'early_sidedress', label: 'Early Sidedress' },
  { key: 'late_sidedress', label: 'Late Sidedress' },
];

export const products = [
  { key: 'instinct-nxtgen', label: 'Instinct NXTGEN' },
  { key: 'instinct', label: 'Instinct' },
  { key: 'guardian-l', label: 'Guardian-L' },
  { key: 'centuro', label: 'Centuro' },
  { key: 'n-serve', label: 'N-Serve' },
  { key: 'function', label: 'Function' },
  { key: 'trident', label: 'Trident' },
];

function PaperComponent(props) {
  const ref = useRef({});

  return (
    <Draggable
      nodeRef={ref}
      handle="#draggable-dialog-title"
      cancel={'[class*="MuiDialogContent-root"]'}
    >
      <Paper
        ref={ref}
        sx={{ borderTop: '8px solid #629749', maxWidth: 'none !important' }}
        {...props}
      />
    </Draggable>
  );
}

export default function DownloadDialog(props) {
  const { onClose, title, fields } = props;
  const [options, setOptions] = useState({});

  return (
    <Dialog
      open
      onClose={handleClose}
      PaperComponent={PaperComponent}
      aria-labelledby="draggable-dialog-title"
    >
      <DialogTitle sx={{ cursor: 'move', backgroundColor: '#fff !important' }}>
        {title}
      </DialogTitle>
      <IconButton
        aria-label="close"
        onClick={handleClose}
        sx={{
          position: 'absolute',
          right: 8,
          top: 8,
          color: (theme) => theme.palette.grey[500],
        }}
      >
        <CloseIcon />
      </IconButton>
      <DialogContent sx={{ padding: '36px 24px 56px !important' }}>
        <DownloadOptions prescriptions={fields} setOptions={setOptions} />
      </DialogContent>
      <DialogActions sx={{ padding: '8px 24px' }}>
        <Button
          autoFocus
          onClick={clickHandler(handleClose)}
          variant="contained"
          color="inherit"
        >
          Cancel
        </Button>
        <Button
          autoFocus
          onClick={clickHandler(handleSave)}
          variant="contained"
          disabled={!options?.timing || !options?.product}
        >
          Save
        </Button>
      </DialogActions>
    </Dialog>
  );

  function handleClose() {
    onClose();
  }

  function handleSave() {
    onClose(options.timing, options.product);
  }

  function clickHandler(handler) {
    return (event) => {
      event.stopPropagation();
      handler();
    };
  }
}
